module.exports = __webpack_public_path__ + "static/media/Illus-Diversity_2@3x.c9fefbd3.png";